import {
  Dialog,
  DialogTitle,
  DialogContent,
  Grid,
  Card,
  CardActionArea,
  Avatar,
  Typography,
  Box,
  IconButton,
} from '@mui/material'
import { Close } from '@mui/icons-material'
import { useAuthStore } from '@/store/useAuthStore'
import { useFamilyStore } from '@/store/useFamilyStore'

interface UserSwitcherProps {
  open: boolean
  onClose: () => void
}

export default function UserSwitcher({ open, onClose }: UserSwitcherProps) {
  const setCurrentUser = useAuthStore((state) => state.setCurrentUser)
  const currentUserId = useAuthStore((state) => state.currentUserId)
  const members = useFamilyStore((state) => state.members)

  const handleSelectUser = (userId: string) => {
    setCurrentUser(userId)
    onClose()
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Switch User
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', right: 8, top: 8 }}
        >
          <Close />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          {members.map((member) => (
            <Grid item xs={6} sm={4} key={member.id}>
              <Card
                sx={{
                  border: currentUserId === member.id ? 2 : 0,
                  borderColor: 'primary.main',
                }}
              >
                <CardActionArea
                  onClick={() => handleSelectUser(member.id)}
                  sx={{ p: 2 }}
                >
                  <Box
                    display="flex"
                    flexDirection="column"
                    alignItems="center"
                    gap={1}
                  >
                    <Avatar
                      src={member.avatar_url || undefined}
                      sx={{
                        width: 64,
                        height: 64,
                        bgcolor: member.color,
                        fontSize: '1.5rem',
                      }}
                    >
                      {member.name[0]}
                    </Avatar>
                    <Typography variant="body2" fontWeight="medium">
                      {member.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {member.points} pts
                    </Typography>
                  </Box>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </DialogContent>
    </Dialog>
  )
}
